import type { EventRecord } from "@/shared/domain/events";

/**
 * The events `isEventVisible` admits, in their original order. Pass the
 * resolver from `useEventVisibilityResolver` rather than a local visibility
 * test, so this surface hides exactly what the timeline, the plot annotations,
 * and the sidebar hide.
 */
export function selectVisibleEvents(
  events: EventRecord[],
  isEventVisible: (event: EventRecord) => boolean,
): EventRecord[] {
  return events.filter(isEventVisible);
}

/**
 * The subset of `events` whose time window contains `timeNs`. Both bounds are
 * inclusive, and `timeNs` and the event bounds are all absolute nanosecond
 * epochs (bigint), so they compare directly.
 */
export function selectActiveEvents(
  events: EventRecord[],
  timeNs: bigint,
): EventRecord[] {
  return events.filter(
    (event) => event.start_time <= timeNs && timeNs <= event.end_time,
  );
}
